import { useEffect, useState } from 'react'

import { getMethod } from '../../../api/methods'
import API_ROUTES from '../../../api/routes'
import useRedux from '../../../hooks/useRedux'
import useTranslations from '../../../hooks/useTranslations'
import { setFiscalYear, setPopupMessageModel } from '../../../redux/app/reducer'
import { dayJs } from '../../../utils/dayjs'
import { isEqual, length } from '../../../utils/javascript'
import { exportToExcelApi } from '../report.api'

const stock = 'stock'
const purchase = 'PURCHASE_INFO_SHEET'

const tallyReports = () => {
  const { t } = useTranslations()
  const { dispatch, selector } = useRedux()
  const fiscalYearOptions = selector(state => state?.app?.fiscalYear?.options)

  const [viewPreviousHistory, setViewPreviousHistory] = useState({
    open: false,
    sheetType: '',
  })
  const [dateRanges, setDateRanges] = useState({
    [stock]: {
      range: [],
      fiscalYear: '',
    },
    [purchase]: {
      range: [],
      fiscalYear: '',
    },
  })
  const [sourceType, setSourceType] = useState(
    'STOCK_ITEMS_COLLECTION_CENTER_SHEET',
  )

  useEffect(() => {
    const getFiscalYears = async () => {
      const { data } = await getMethod(API_ROUTES.FISCAL_YEARS)

      const list = data?.data?.list
      const fiscalOptions =
        list?.map(({ year }) => ({ label: year, value: year })) || []
      const lastElem = fiscalOptions.at(length(fiscalOptions) - 1)
      const year = lastElem?.value
      const startDate = dayJs(`${year}-04-01`)
      const endDate = dayJs(`${year + 1}-03-31`)
      const range = [startDate, endDate]
      setDateRanges({
        [stock]: { range, fiscalYear: year },
        [purchase]: { range, fiscalYear: year },
      })

      dispatch(
        setFiscalYear({
          options: fiscalOptions,
        }),
      )
    }
    getFiscalYears()
  }, [])

  const onGenerateReport = async ({ sheetType }) => {
    const payload = {
      type: sheetType,
      fiscalYear: dateRanges?.[sheetType]?.fiscalYear,
      from: dateRanges?.[sheetType]?.range?.[0]?.format('DD/MM/YYYY'),
      to: dateRanges?.[sheetType]?.range?.[1]?.format('DD/MM/YYYY'),
      ...(isEqual(sheetType, stock) && {
        type: sourceType,
      }),
    }

    const response = await exportToExcelApi({ payload })
    if (response?.data?.success) {
      dispatch(
        setPopupMessageModel({
          open: true,
          message: t('msg_ReportGenerated'),
          success: true,
        }),
      )
    }
  }

  const onDateRangeChange = (sheetType, dateRange) => {
    setDateRanges(prev => ({
      ...prev,
      [sheetType]: { ...prev[sheetType], range: dateRange },
    }))
  }

  const onFiscalYearChange = (sheetType, fiscalYear) => {
    const startDate = dayJs(`${fiscalYear}-04-01`)
    const endDate = dayJs(`${fiscalYear + 1}-03-31`)
    const range = [startDate, endDate]
    setDateRanges(prev => ({
      ...prev,
      [sheetType]: { ...prev[sheetType], fiscalYear, range },
    }))
  }

  const onViewHistoryModelClose = () => {
    setViewPreviousHistory({ open: false })
  }

  const reportsTypeList = [
    {
      title: 'rpt_StockItemsTemplate',
      sheetType: stock,
      generateReportLabel: 'btn_GenerateStockItemsTemplate',
      showSource: true,
      onSourceChange: val => setSourceType(val),
      dateLabel: isEqual('STOCK_ITEMS_COLLECTION_CENTER_SHEET', sourceType)
        ? 'job_DateOfReceiptOfVehicleAtCollectionCenter'
        : 'job_DateOfReceiptOfVehicle',
      onViewClick: () =>
        setViewPreviousHistory({
          open: true,
          sheetType: sourceType,
        }),
    },
    {
      title: 'rpt_PurchaseReport',
      sheetType: purchase,
      generateReportLabel: 'btn_GeneratePurchaseReport',
      dateLabel: 'job_DateOfReceiptOfVehicle',
      onViewClick: () =>
        setViewPreviousHistory({
          open: true,
          sheetType: purchase,
        }),
    },
  ]

  return {
    t,
    sourceType,
    dateRanges,
    reportsTypeList,
    fiscalYearOptions,
    viewPreviousHistory,
    setViewPreviousHistory,
    onGenerateReport,
    onDateRangeChange,
    onFiscalYearChange,
    onViewHistoryModelClose,
  }
}

export default tallyReports
